import { useNavigate } from 'react-router-dom';
import { useWizardStore, type WizardType } from '../store/wizardStore';
import { useWizardTemplate } from '../hooks/useSywData';
import { useEffect } from 'react';

interface TypeCard {
  type: WizardType;
  label: string;
  subtitle: string;
  rooms: string;
}

const TYPES: TypeCard[] = [
  { type: 'T0', label: 'T0', subtitle: 'Estúdio', rooms: '1–2 divisões' },
  { type: 'T1', label: 'T1', subtitle: '1 quarto', rooms: '3–4 divisões' },
  { type: 'T2', label: 'T2', subtitle: '2 quartos', rooms: '4–5 divisões' },
  { type: 'T3', label: 'T3', subtitle: '3 quartos', rooms: '6–7 divisões' },
  { type: 'T4', label: 'T4', subtitle: '4 quartos', rooms: '7–8 divisões' },
  { type: 'Moradia', label: '🏠', subtitle: 'Moradia', rooms: '8+ divisões' },
];

export function WizardPickerPage() {
  const navigate = useNavigate();
  const { wizardType, setWizardType, setDivisions } = useWizardStore();
  const { divisions, loading } = useWizardTemplate(wizardType);

  // When template loads, seed divisions into store
  useEffect(() => {
    if (divisions.length > 0) {
      setDivisions(divisions as Parameters<typeof setDivisions>[0]);
    }
  }, [divisions, setDivisions]);

  function handleSelect(type: WizardType) {
    setWizardType(type);
  }

  function handleNext() {
    if (!wizardType) return;
    navigate(`/wizard/${wizardType}`);
  }

  return (
    <div className="mx-auto max-w-2xl px-4 py-10">
      <div className="mb-8">
        <button
          type="button"
          onClick={() => navigate('/')}
          className="mb-4 text-sm text-smartify-muted hover:text-smartify-ink"
        >
          ← Voltar
        </button>
        <h1 className="text-xl font-bold text-smartify-ink">Qual é a tipologia?</h1>
        <p className="mt-1 text-sm text-smartify-muted">
          Escolhe a que mais se aproxima — depois podes ajustar divisão a divisão.
        </p>
      </div>

      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
        {TYPES.map(({ type, label, subtitle, rooms }) => {
          const selected = wizardType === type;
          return (
            <button
              key={type}
              type="button"
              aria-pressed={selected}
              onClick={() => handleSelect(type)}
              className={[
                'flex flex-col items-center rounded-smartify border p-5 text-center transition-colors',
                selected
                  ? 'border-smartify-brand bg-smartify-brand text-white'
                  : 'border-smartify-line bg-white text-smartify-ink hover:border-smartify-accent',
              ].join(' ')}
            >
              <span className="text-3xl font-bold">{label}</span>
              <span className={['mt-1 text-sm font-medium', selected ? 'text-white' : 'text-smartify-ink'].join(' ')}>
                {subtitle}
              </span>
              <span className={['mt-0.5 text-xs', selected ? 'text-white/80' : 'text-smartify-muted'].join(' ')}>
                {rooms}
              </span>
            </button>
          );
        })}
      </div>

      <div className="mt-8 flex justify-end">
        <button
          type="button"
          disabled={!wizardType || loading}
          onClick={handleNext}
          className="rounded-smartify bg-smartify-brand px-8 py-3 font-semibold text-white transition-opacity hover:opacity-90 disabled:opacity-40"
        >
          {loading ? 'A carregar…' : 'Continuar →'}
        </button>
      </div>
    </div>
  );
}
